import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { ComunidadPublicacionService, ComunidadService, MenuFuncionService } from '../../../../../src/app/shared/services';
import { Comunidad, DashboardComunidadPublicacionItemDto, LocalStorageKeys, MenuFuncionCodes, SearchComunidadRequest } from '../../../../../src/app/shared/model';

@Component({
  selector: 'app-publicaciones',
  templateUrl: './publicaciones.component.html',
  styleUrls: ['./publicaciones.component.scss']
})

export class PublicacionesComponent implements OnInit{

  isValidating: boolean;
  canView: boolean;
  isEndOfList: boolean;

  public data: DataManager;
  public query: Query;

  isPublicacionesSearching: boolean;
  listaPublicaciones: DashboardComunidadPublicacionItemDto[] =  [];
  pageNumber:number;
  pageSize = 2;

  listaComunidades: Comunidad[] = [];
  seleccionComunidadActual: number = 0;

  private subscription: Subscription;

  constructor(
    private sharedFunctions: SharedFunctions,
    private menuService: MenuFuncionService,
    private service: ComunidadPublicacionService,
    private eventEmitterService: EventEmiterService,
    private comunidadService: ComunidadService,
    private router: Router
  ) {
    this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
      this.loadView();
    });
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_PUBLICACIONES).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.canView = true;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadView() {
    this.pageNumber = 0
    this.listaPublicaciones = [];
    this.isEndOfList = false;
    this.seleccionComunidadActual = 0;

    this.setQueryParams(this.pageNumber, this.pageSize, 0);
    this.data = new DataManager({
      url: this.service.getDashboardPublicacionesUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.getComunidades();
    this.getPublicaciones();

  }

  setQueryParams(pageNumber:number, pageSize:number, comunidadId:number) {
    if (this.query == null)
      this.query = new Query();

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = cId;
    else
      this.query.addParams("ConsorcioId", cId);

    var index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = comunidadId.toString();
    else
      this.query.addParams("ComunidadId", comunidadId.toString());

    index = this.query.params.findIndex(obj => obj.key === "top");
    if (index >= 0)
      this.query.params[index].value = this.pageSize.toString();
    else
      this.query.addParams("top", this.pageSize.toString());


    index = this.query.params.findIndex(obj => obj.key === "PageSize");
    if (index >= 0)
      this.query.params[index].value = pageSize.toString();
    else
      this.query.addParams("PageSize", pageSize.toString());

    index = this.query.params.findIndex(obj => obj.key === "PageNumber");
    if (index >= 0)
      this.query.params[index].value = pageNumber.toString();
    else
      this.query.addParams("PageNumber", pageNumber.toString());
  }

  //Busca la primera vez al cargar la vista, una cantidad específica de publicaciones
  getPublicaciones(){
    this.data.executeQuery(this.query).then((response:any) => {
      const eofList = this.verificarFinPaginacion(response.result.result, this.pageSize);

      for(let publicacion of response.result.result){
        if(!this.listaPublicaciones.some(p => p.Id == publicacion.Id))
          this.listaPublicaciones.push(publicacion);
      }

      if(eofList){
        this.pageNumber = 0;
        this.setQueryParams(this.pageNumber, this.pageSize, this.seleccionComunidadActual);
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades(){
    var consorcioIdLocalStorage = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    var r = new SearchComunidadRequest(0, 0, true, "Nombre", null, consorcioIdLocalStorage, null, null, null, true);

    this.comunidadService.search(r).subscribe(data =>{
      this.listaComunidades = data.result;
    },(err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  getTraduccion(value: string) {
    return this.sharedFunctions.getNombreMenuTenant(value);
  }

  //Activa el filtrado de publicaciones por la comunidad/edif. seleccionado
  onComunidadSelect(event:any){
    const seleccion = event.value;
    this.seleccionComunidadActual = seleccion;

    this.pageNumber = 0
    this.listaPublicaciones = [];
    this.isEndOfList = false;
    this.setQueryParams(this.pageNumber, this.pageSize, seleccion);
    this.getPublicaciones();
  }

  //Relacionado al Botón de la publicación particular
  view(item: DashboardComunidadPublicacionItemDto){
    if (!item || item.Id == null || item.Id <= 0){
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }
    this.router.navigate(['comunidad-publicacion-view', item.Id]);
  }

  //Relacionado al Boton de Paginación
  onSearch(){
    var consorcioIdLocalStorage = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);

    this.pageNumber++;
    this.setQueryParams(this.pageNumber, this.pageSize, this.seleccionComunidadActual);
    this.getPublicaciones();
  }

  verificarFinPaginacion(listaElementos:any, pageSize:number):boolean{
    var result = false;
    if(listaElementos.length < pageSize){
      this.pageNumber = 0;
      this.isEndOfList = true;
      result = true;
    }
    return result;
  }

  /*Toma un string y devuelve una parte definida del mismo*/
  getTruncatedText(text:string | null, limit:number){
    if (text !== null)
      return text.length > limit ? text.substring(0, limit) + ' ...' : text;
  }
}
